import api from "../api";
import { ITema } from "../interfaces/editor/Tema";

const API_BASE = "/api/Temas";

// Lista os temas pai com suas categorias (subtemas) em "categorias".
const listTemas = async function (locale: string) {
  return api.get<ITema[]>(API_BASE, {
    headers: {
      "Accept-Language": locale,
    },
  });
};

const temaService = {
  listTemas,
};

export default temaService;
